export interface IMetaData {
    errorCode: string
    errorDescription: string
}

export interface StandardErrorParams {
    message: string
    title: string
    description: string
    image: string
    redirectURL?: string
    metaData?: IMetaData
    cta?: {
        id: string
        schema_version: string
        button_text: string
    }
}

export default class StandardError extends Error {
    title: string
    description: string
    image: string
    redirectURL?: string
    metaData?: IMetaData
    cta?: {
        id: string
        schema_version: string
        button_text: string
    }

    constructor({
        message,
        title,
        description,
        image,
        redirectURL,
        metaData,
        cta,
    }: StandardErrorParams) {
        super(message)
        this.title = title
        this.description = description
        this.image = image
        this.redirectURL = redirectURL
        this.metaData = metaData
        this.cta = cta
    }
}
